var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrndlyLogoV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144px",
    height: "144px",
    viewBox: "0 0 144 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "299092_calendar_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "299092_calendar_icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,61.6666667 C7.1632,61.6666667 0,56.9474778 0,62 C0,69.2645289 0,72.9333602 0,73.0064938 C0,86.7499067 0,107.365026 0,134.851852 C0,139.906204 7.1632,144 16,144 L64,144 L80,144 L128,144 C136.84,144 144,139.906204 144,134.851852 L144,62 C144,60.5078091 143.197452,62.1198623 142.089581,62 C139.446226,61.7140113 134.229231,62 128,62 L80,61.6666667 L64,61.6666667 L16,61.6666667 Z",
    id: "Path",
    fill: "#ECF0F1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.1632,0 0,9.25246667 0,20.6666667 L0,51.6666667 L0,62 L144,62 L144,51.6666667 L144,20.6666667 C144,9.25246667 136.84,0 128,0 L80,0 L64,0 L16,0 Z",
    id: "Path",
    fill: "#1943D7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 80.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-6.82121026e-13 L0,16 L16,16 L16,-6.82121026e-13 L0,-6.82121026e-13 Z M24,-6.82121026e-13 L24,16 L40,16 L40,-6.82121026e-13 L24,-6.82121026e-13 Z M48,-6.82121026e-13 L48,16 L64,16 L64,-6.82121026e-13 L48,-6.82121026e-13 Z M72,-6.82121026e-13 L72,16 L88,16 L88,-6.82121026e-13 L72,-6.82121026e-13 Z",
    id: "Shape",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,26 L48,42 L64,42 L64,26 L48,26 Z M72,26 L72,42 L88,42 L88,26 L72,26 Z M96,26 L96,42 L112,42 L112,26 L96,26 Z",
    id: "Shape-Copy",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check_24dp_E8EAED_FILL0_wght700_GRAD0_opsz24-Copy",
    transform: "translate(94.000000, 2.000000)",
    fill: "#1943D7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6.5 13.65 0 7.15 2.25 4.9 6.5 9.15 15.65 0 17.9 2.25"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0,26 L0,42 L16,42 L16,26 L0,26 Z M24,26 L24,42 L40,42 L40,26 L24,26 Z",
    id: "Shape",
    fill: "#BDC3C7"
  })), /*#__PURE__*/React.createElement("text", {
    id: "frndly",
    fontFamily: "ArialRoundedMTBold, Arial Rounded MT Bold",
    fontSize: 35,
    fontWeight: "normal",
    letterSpacing: 0.116666653,
    fill: "#ECF0F1"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 22.9227051,
    y: 46
  }, "frndly"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrndlyLogoV2);
export default __webpack_public_path__ + "static/media/frndly-logo-v2.3790d353c9f61a13359abce43c559665.svg";
export { ForwardRef as ReactComponent };